/**
 * Region-aware brand logo utility.
 * Returns the correct logo images based on the current region.
 */
import regionConfig from '../config/regionConfig';

// BR logos
import logoPedeJA from '../img/logoPedeJA.png';
import logoBlue from '../img/logoBlue.png';
import logoP from '../img/logoP.png';

// EasyOrder logos
import EasyOrderText from '../img/EasyOrderText.png';
import EasyOrderLogo from '../img/EasyOrderLogo.png';

const isBR = regionConfig.region === 'br';

/** Full text logo (e.g., registration sidebar, landing page) */
export const brandTextLogo = isBR ? logoPedeJA : EasyOrderText;

/** Main brand logo for login/auth pages */
export const brandLogo = isBR ? logoBlue : EasyOrderText;

/** Small icon logo (e.g., sidebar menu) */
export const brandIcon = isBR ? logoP : EasyOrderLogo;

/** Brand name */
export const brandName = regionConfig.brand.name;
